import services from './services';
import {
	lg,
	cloneDeep,
	util,
	isCorrectVal,
	isDate
} from 'utils';
import NProgress from 'nprogress';
import networkModalDialog from './components/networkModalDialog/index.vue'
import completeDialog from './components/completeDialog/index.vue'
export default {
	mixins: [services],
	components: {
		networkModalDialog,
		completeDialog
	},
	data() {
		return {
			loading: false,
			lists: [],
			pageIndex: 1,
			pageSize: 10,
			totalSize: '',
			sels: [], //列表选中列
			pageSizes: [10, 20, 50],
			query: this.getQuery(),
			dropDowns: [],
			Id: '',
			FollowId: '',
			schoolList: [],
			classList: [],
			ModuleEmployee:[{
				Id: 0,
				EmployeeName: '全部'
			}],
			OptionTypes: [{
				id: 0,
				name: '全部'
			}, {
				id: 1,
				name: '设备安装'
			}, {
				id: 2,
				name: '网络检测'
			}, {
				id: 10,
				name: '已完成网络检测 '
			}],
			totalData: [],
			FollowTypes: [],
			ITServiceTypes: [{
				Id: 0,
				name: '不需要'
			}, {
				Id: 1,
				name: '需要'
			}]

		}
	},
	methods: {
		getQuery() {
			return cloneDeep({
				SchoolId: '',
				ClassId: '',
				SalesMan: '',
				PrincipalName: '',
				PrincipalTel: '',
				CheckStatus: 0,
				FollowStatus: '',
				StockOutStartTime: '',
				StockOutEndTime: '',
				FollowStartTime: '',
				FollowEndTime: '',
				OrderCode: '',
				orderBy: 'StockOutTime desc',
				IT_Service: '',
				FollowEmployeeName: ''

			});
		},
		// 排序
		sortChange(val) {
			if (val.prop !== null) {
				let word = val.prop
				if (val.prop == 'FolllowTime') {
					word = 'LastFollowTime '
				}
				if (val.order == 'ascending') {
					this.query.orderBy = word + ' ' + 'asc'
				} else {
					this.query.orderBy = word + ' ' + 'desc'
				}
			}
			this.getList()
		},
		// 获取修改跟进人下拉列表
		changeFllow(row) {
			this.FollowId = row.FollowId
			this.Id = row.Id
			this.GetFollowEmployeeList(row.Id)
		},
		// 提交修改跟进人
		handleCommand(val) {
			this.ModifyFollowEmployee(this.Id, val, this.FollowId)
		},
		//查看订单
		handleView(index, row) {
			this.$refs.refsModalDialog.show({
				Id: row.Id,
				title: '查看',
				isFollow: false
			})
		},
		// 回退
		handleReturn(row) {
			this.$confirm('确定要回退吗？', '提示', {}).then(() => {
				this.ReturnCheck({
					"NetCheckId": row.Id,
					"CheckStatus": 1
				});
			})

		},
		// 跟进
		handleFllow(index, row) {
			this.$refs.refsModalDialog.show({
				Id: row.Id,
				title: '跟进',
				isFollow: true
			})
		},
		// 完成设备安装下推网络检测
		handleEdit(index, row) {
			if (row.FollowId == 0) {
				// 未进行任何网络检测跟进，无法下推
				this.$notify({
					title: '警告',
					message: '未进行任何网络检测跟进，无法下推',
					type: 'warning'
				});
				return;
			}

			let title = '完成设备安装下推网络检测'
			// if (row.CheckStatus == 1) {
			// 	title = '完成设备安装下推网络检测'
			// } else {
			// 	title = '完成网络检测'
			// }
			this.$refs.refsCompleteDialog.show({
				NetCheckId: row.Id,
				CheckStatus: row.CheckStatus,
				IT_ServiceMoney: row.IT_ServiceMoney,
				title: title,
			})

		},
		// 网络检测下推
		handleEdit2(index, row) {
			if (row.FollowId == 0) {
				// 未进行任何网络检测跟进，无法下推
				this.$notify({
					title: '警告',
					message: '未进行任何网络检测跟进，无法下推',
					type: 'warning'
				});
				return;
			}
			let submitData = {
				"NetCheckId": row.Id,
				"CheckStatus": row.CheckStatus,
				"IT_Service": row.IT_Service,
				"IT_ServiceMoney": row.IT_ServiceMoney
			}
			this.CompleteCheck(submitData)
		},
		// 选择园所
		chooseSchool(val) {
			if (val !== '') {
				this.query.ClassId = ''
				this.classList = []
				this.GetClassList(val)
			}

		},
		//查询
		onQuerySubmit: function () {
			this.pageIndex = 1;
			this.getList();
		},
		//查询功能
		handleSizeChange: function (val) {
			this.pageSize = val;
			this.getList();
		},
		onQueryClean: function () {
			this.query = this.getQuery();
			this.getList();
		},
		handleCurrentChange: function (val) {
			this.pageIndex = val;
			this.getList();
		}
	},
	created() {
		this.query = this.getQuery();
		this.getList();
		this.GetSchoolList()
	},
	computed: {
		isAllData() {
			let currentPath = this.$route.path
			if (currentPath == '/Network/networkListAll') {
				return true
			}
			return false
		}
	},
	watch: {
		'$route' (to, from) {
			this.$nextTick(() => {
				this.query = this.getQuery();
				this.getList();
			})
		},
		'query.CheckStatus' (currentValue) {
			this.query.FollowStatus = ''
			this.GetOptionByModId(currentValue)
		}
	},

}


// WEBPACK FOOTER //
// ./src/pages/Network/networkCheck/vm.js